import moment from "moment";

export function useAuthenticatedUser(user: any) {
  const expirationDate = moment.utc(user?.id_token_expiration).format();
  const now = moment.utc().format();
  const authenticatedUser = Boolean(user && expirationDate > now);

  return authenticatedUser;
}
